import WFacebookComment_WithConsentWrapperComponent from '@wix/thunderbolt-elements/src/components/WFacebookComment/viewer/skinComps/WithConsentWrapper/WithConsentWrapper.skin';
import WFacebookComment_WithConsentWrapperController from '@wix/thunderbolt-elements/src/components/WFacebookComment/viewer/WFacebookComment.controller';


const WFacebookComment_WithConsentWrapper = {
  component: WFacebookComment_WithConsentWrapperComponent,
  controller: WFacebookComment_WithConsentWrapperController
};


export const components = {
  ['WFacebookComment_WithConsentWrapper']: WFacebookComment_WithConsentWrapper
};

